import React, { useState, useEffect, useRef } from 'react';
import Feature from '../../components/feature/Feature';
import './whatGPT3.css';
import Typewriter from "typewriter-effect";

const WhatP = () => {
  const [inViewport, setInViewport] = useState(false);
  const whatgpt3headingRef = useRef(null);

  useEffect(() => {
    function handleScroll() {
      if (whatgpt3headingRef.current) {
        const { top, bottom } = whatgpt3headingRef.current.getBoundingClientRect();
        if (top < window.innerHeight && bottom > 0) {
          setInViewport(true);
        }
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="What is Parathesis-AI?" text="We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by." />
    </div>
    <div className="gpt3__whatgpt3-heading" ref={whatgpt3headingRef}>
      <h1 className="gradient__text">
          {inViewport &&
      <Typewriter
          options={{
          strings: "The possibilities are beyond your imagination",
          autoStart: true,
           loop: false,
           }}
           />
          }
          </h1>
      <p>Explore the Library</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature title="Chatbots" text="We so opinion friends me message as delight. Whole front do of plate heard oh ought." />
      <Feature title="Knowledgebase" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b" />
      <Feature title="Education" text="At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b" />
    </div>
  </div>
);
};
export default WhatP;
